import React from 'react';
import { Typography, Icon } from 'kangarootime-ui';
import { Tooltip } from '@material-ui/core';
import { withRouter } from 'react-router';

const Header = ({
  username,
  isManager,
  ...props
}) => {
  return (
    <div className='flex-rows' style={{ padding: '12px 12px 0 12px', alignItems: 'center' }}>
      <Typography style={{ color: '#AB9BA9', fontWeight: 400, flex: 1 }}>{username}</Typography>
      { isManager &&
        <Tooltip title='Message Overview' placement='bottom'>
          <div style={{ cursor: 'pointer' }} onClick={() => props.history.push('/messages/overview')}>
            <Icon icon='search' color='#AB9BA9' height={24} width={24} />
          </div>
        </Tooltip>
      }
    </div>
  );
};

export default withRouter(Header);
